import {
  billingExplorerWidgetForecastedMonthlyCostColId,
  billingExplorerWidgetForecastedQuarterlyCostColId,
  billingExplorerWidgetPrevCostColId,
  billingExplorerWidgetTotalCostColId,
} from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/billingExplorerWidgetAgGridColumnDefs";

export const billingExplorerWidgetGridWrapperStyles = {
  [`[col-id="${billingExplorerWidgetTotalCostColId}"] .ag-header-cell-label, 
    [col-id="${billingExplorerWidgetPrevCostColId}"] .ag-header-cell-label,
    [col-id="${billingExplorerWidgetForecastedMonthlyCostColId}"] .ag-header-cell-label,
    [col-id="${billingExplorerWidgetForecastedQuarterlyCostColId}"] .ag-header-cell-label`]:
    {
      justifyContent: "flex-end",
    },
};

export const billingExplorerWidgetGridDefaultColDef = {
  flex: 3,
  minWidth: 170,
  sortable: true,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
};
